import _defineProperty from "@babel/runtime/helpers/defineProperty";
// TODO: re-implement it as a part of the abstraction over ClientSpecMap
// Jira task: https://jira.wixpress.com/browse/EP-3788
export class ApplicationSpecExtractorComposite {
  constructor(ps) {
    this.ps = ps;
    _defineProperty(this, "extractors", []);
    this.ps = ps;
  }
  with(extractor) {
    this.extractors.push(extractor);
    return this;
  }
  execute() {
    const installedApps = this.ps.ds.platform.getInstalledApps();
    return installedApps.flatMap(app => this.extractors.flatMap(extractor => extractor.extract(app)));
  }
}
//# sourceMappingURL=index.js.map